var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"wrapper text-unselectable",class:[
    { 'is-active': _vm.isActive },
    { rounded: _vm.isRounded },
    { small: _vm.isSmall },
    { 'extra-small': _vm.isExtraSmall }
  ],on:{"change":function($event){return _vm.$emit('change', !_vm.isActive)}}},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"wrapper-content",class:{ 'wrapper-content-small': _vm.isSmall || _vm.isExtraSmall }},[(_vm.icon)?_c('div',{staticClass:"icon-wrapper"},[_c('AImage',{attrs:{"url":_vm.icon,"classes":['icon-choice']}})],1):_vm._e(),_c('div',{staticClass:"text",class:{ 'text-small': _vm.isSmall || _vm.isExtraSmall }},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }